import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, defaultProps } from 'recompose';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';
import createAdapter from '../../../utils/fuseFilterAdapter';
import { querySelector } from '../../../utils';
import LookupResultListItem from '../../lookups/components/LookupResultListItem';
import CompatLookupResultListItem from '../../lookups/components/CompatLookupResultListItem';

/* eslint-disable */
const propTypes = {
  operators: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
  lookupJoinType: PropTypes.oneOf(['user_records', 'lookup_records', 'union']),
  createOperator: PropTypes.func.isRequired,
  data: PropTypes.object,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,

  enableLookup: PropTypes.bool,
};


export class OperatorInput extends Component {
  /* eslint-enable */
  render() {
    const {
      operators, value, disabled, onChange, onBlur, onFocus, enableLookup,
    } = this.props;
    const filter = createAdapter(operators);
    const itemComponent = enableLookup ? LookupResultListItem : CompatLookupResultListItem;

    /* NOTE: 5/24/2018 removing ability to create operators inline */
    return (
      <InputGroup>
        <DropdownList
          disabled={disabled}
          inputProps={{
            className: 'form-control',
          }}
          filter={filter}
          value={value}
          data={operators}
          onChange={onChange}
          valueField="id"
          textField="name"
          onFocus={onFocus}
          onBlur={() => { onBlur(); }}
          itemComponent={itemComponent}
        />
        <InputGroup.Button>
          <Button
            name="cancel"
            disabled={!value || disabled}
            /* calling onBlur event to change touched flag to show error if need be */
            onClick={(e) => {
              onBlur(e);
              onChange(null);
            }}
          >
            <Glyphicon glyph="remove" />
          </Button>
        </InputGroup.Button>
      </InputGroup>
    );
  }
}

OperatorInput.propTypes = propTypes;

export const OperatorInputOperatorFragment = gql`
  fragment OperatorInputOperatorLookup on OperatorLookupResult {
    id
    user_id
    lookup_id
    name
    lookup_status
    lookupStatus: lookup_status
  }
`;

const GetAllOperatorsQuery = gql`
  query GetAllOperators($lookupJoinType: LookupJoinTypes!) {
    all_operators: lookup_operators(lookup_query: {join_type: $lookupJoinType}) {
      edges {
        node {
          ...OperatorInputOperatorLookup
        }
      }
    }
  }
  ${OperatorInputOperatorFragment}
`;

const CreateOperatorMutation = gql`
  mutation CreaterOperator($input: OperatorCreateInput!) {
    operator_create(input: $input) {
      ...OperatorInputOperatorLookup
    }
  }
  ${OperatorInputOperatorFragment}
`;


export const marshallData = ({ data, ownProps }) => {
  const operators = querySelector(data, '$.all_operators.edges[*].node', []);
  return {
    ...ownProps,
    data,
    operators,
  };
};

const withData = graphql(GetAllOperatorsQuery, { props: marshallData });
const withCreate = graphql(CreateOperatorMutation, { name: 'createOperator' });

const enhance = compose(
  defaultProps({ lookupJoinType: 'user_records', enableLookup: false }),
  withData,
  withCreate,
);

export default enhance(OperatorInput);
